import { GRADIENT_ALICE_BLUE_END, GRADIENT_ALICE_BLUE_START, GRADIENT_AQUA_SPLASH_END, GRADIENT_AQUA_SPLASH_START, GRADIENT_COOL_SKY_END, GRADIENT_COOL_SKY_START, GRADIENT_DANGER_END, GRADIENT_DANGER_START, GRADIENT_DODGER_BLUE_CENTER, GRADIENT_DODGER_BLUE_END, GRADIENT_DODGER_BLUE_START, GRADIENT_FLAME_END, GRADIENT_FLAME_START, GRADIENT_LUSH_END, GRADIENT_LUSH_START, GRADIENT_MANTLE_END, GRADIENT_MANTLE_START, GRADIENT_MINT_GREEN_END, GRADIENT_MINT_GREEN_START, GRADIENT_MOUNTAIN_ROCK_END, GRADIENT_MOUNTAIN_ROCK_START, GRADIENT_PEACH_END, GRADIENT_PEACH_START, GRADIENT_PREMIUM_DARK_END, GRADIENT_PREMIUM_DARK_START, GRADIENT_PURPLIN_END, GRADIENT_PURPLIN_START, GRADIENT_RETRO_END, GRADIENT_RETRO_START, GRADIENT_SEA_GREEN_CENTER, GRADIENT_SEA_GREEN_END, GRADIENT_SEA_GREEN_START, GRADIENT_SIN_CITY_END, GRADIENT_SIN_CITY_START, GRADIENT_STELLAR_END, GRADIENT_STELLAR_START, GRADIENT_SUCCESS_END, GRADIENT_SUCCESS_START, GRADIENT_SUNRISE_END, GRADIENT_SUNRISE_START, GRADIENT_WARNING_END, GRADIENT_WARNING_START } from '../colors';
var gradientViewConfig = {
  theme: 'light',
  type: 'RETRO',
  config: {
    SUCCESS: {
      x1: '216.388%',
      x2: '216.388%',
      y1: '3.556%',
      y2: '98%',
      colorSet: [{
        offset: 0,
        stopColor: GRADIENT_SUCCESS_START
      }, {
        offset: 1,
        stopColor: GRADIENT_SUCCESS_END
      }]
    },
    WARNING: {
      x1: '216.388%',
      x2: '216.388%',
      y1: '3.556%',
      y2: '98%',
      colorSet: [{
        offset: 0,
        stopColor: GRADIENT_WARNING_START
      }, {
        offset: 1,
        stopColor: GRADIENT_WARNING_END
      }]
    },
    DANGER: {
      x1: '216.388%',
      x2: '216.388%',
      y1: '3.556%',
      y2: '98%',
      colorSet: [{
        offset: 0,
        stopColor: GRADIENT_DANGER_START
      }, {
        offset: 1,
        stopColor: GRADIENT_DANGER_END
      }]
    },
    RETRO: {
      x1: '0%',
      x2: '8.306%',
      y1: '0%',
      y2: '144.53%',
      colorSet: [{
        offset: 0,
        stopColor: GRADIENT_RETRO_START
      }, {
        offset: 1,
        stopColor: GRADIENT_RETRO_END
      }]
    },
    SUNRISE: {
      x1: '121.75%',
      x2: '-8.684%',
      y1: '86%',
      y2: '-89.648%',
      colorSet: [{
        offset: 0,
        stopColor: GRADIENT_SUNRISE_START
      }, {
        offset: 1,
        stopColor: GRADIENT_SUNRISE_END
      }]
    },
    DODGER_BLUE: {
      isRadial: true,
      cx: '68%',
      cy: '-50%',
      r: '120%',
      colorSet: [{
        offset: 0,
        stopColor: GRADIENT_DODGER_BLUE_START
      }, {
        offset: 0.5,
        stopColor: GRADIENT_DODGER_BLUE_CENTER
      }, {
        offset: 1,
        stopColor: GRADIENT_DODGER_BLUE_END
      }]
    },
    SEA_GREEN: {
      x1: '25.642%',
      x2: '33.457%',
      y1: '-50%',
      y2: '99.522%',
      colorSet: [{
        offset: 0.042,
        stopColor: GRADIENT_SEA_GREEN_START
      }, {
        offset: 0.615,
        stopColor: GRADIENT_SEA_GREEN_CENTER
      }, {
        offset: 1,
        stopColor: GRADIENT_SEA_GREEN_END
      }]
    },
    LUSH: {
      x1: '121.75%',
      x2: '-8.684%',
      y1: '86%',
      y2: '-89.648%',
      colorSet: [{
        offset: 0,
        stopColor: GRADIENT_LUSH_START
      }, {
        offset: 1,
        stopColor: GRADIENT_LUSH_END
      }]
    },
    COOL_SKY: {
      x1: '121.75%',
      x2: '-8.684%',
      y1: '86%',
      y2: '-89.648%',
      colorSet: [{
        offset: 0,
        stopColor: GRADIENT_COOL_SKY_START
      }, {
        offset: 1,
        stopColor: GRADIENT_COOL_SKY_END
      }]
    },
    PURPLIN: {
      x1: '121.75%',
      x2: '-8.684%',
      y1: '86%',
      y2: '-89.648%',
      colorSet: [{
        offset: 0,
        stopColor: GRADIENT_PURPLIN_START
      }, {
        offset: 1,
        stopColor: GRADIENT_PURPLIN_END
      }]
    },
    PREMIUM_DARK: {
      x1: '121.75%',
      x2: '-8.684%',
      y1: '86%',
      y2: '-89.648%',
      colorSet: [{
        offset: 0,
        stopColor: GRADIENT_PREMIUM_DARK_START
      }, {
        offset: 1,
        stopColor: GRADIENT_PREMIUM_DARK_END
      }]
    },
    MOUNTAIN_ROCK: {
      x1: '121.75%',
      x2: '-8.684%',
      y1: '86%',
      y2: '-89.648%',
      colorSet: [{
        offset: 0,
        stopColor: GRADIENT_MOUNTAIN_ROCK_START
      }, {
        offset: 1,
        stopColor: GRADIENT_MOUNTAIN_ROCK_END
      }]
    },
    SIN_CITY: {
      x1: '121.75%',
      x2: '-8.684%',
      y1: '86%',
      y2: '-89.648%',
      colorSet: [{
        offset: 0,
        stopColor: GRADIENT_SIN_CITY_START
      }, {
        offset: 1,
        stopColor: GRADIENT_SIN_CITY_END
      }]
    },
    PEACH: {
      x1: '-5.5%',
      x2: '107.855%',
      y1: '5.5%',
      y2: '251.187%',
      colorSet: [{
        offset: 0,
        stopColor: GRADIENT_PEACH_START
      }, {
        offset: 1,
        stopColor: GRADIENT_PEACH_END
      }]
    },
    FLAME: {
      x1: '-5.5%',
      x2: '107.855%',
      y1: '5.5%',
      y2: '251.187%',
      colorSet: [{
        offset: 0,
        stopColor: GRADIENT_FLAME_START
      }, {
        offset: 1,
        stopColor: GRADIENT_FLAME_END
      }]
    },
    MINT_GREEN: {
      x1: '-5.5%',
      x2: '107.855%',
      y1: '5.5%',
      y2: '251.187%',
      colorSet: [{
        offset: 0,
        stopColor: GRADIENT_MINT_GREEN_START
      }, {
        offset: 1,
        stopColor: GRADIENT_MINT_GREEN_END
      }]
    },
    AQUA_SPLASH: {
      x1: '-5.5%',
      x2: '107.855%',
      y1: '5.5%',
      y2: '251.187%',
      colorSet: [{
        offset: 0,
        stopColor: GRADIENT_AQUA_SPLASH_START
      }, {
        offset: 1,
        stopColor: GRADIENT_AQUA_SPLASH_END
      }]
    },
    ALICE_BLUE: {
      x1: '-5.5%',
      x2: '107.855%',
      y1: '5.5%',
      y2: '251.187%',
      colorSet: [{
        offset: 0,
        stopColor: GRADIENT_ALICE_BLUE_START
      }, {
        offset: 1,
        stopColor: GRADIENT_ALICE_BLUE_END
      }]
    },
    STELLAR: {
      x1: '-5.76245%',
      x2: '82.6329%',
      y1: '0.000483878%',
      y2: '-95.4526%',
      colorSet: [{
        offset: 0,
        stopColor: GRADIENT_STELLAR_START
      }, {
        offset: 1,
        stopColor: GRADIENT_STELLAR_END,
        stopOpacity: 0.878431
      }]
    },
    MANTLE: {
      x1: '-5.5%',
      x2: '107.855%',
      y1: '5.5%',
      y2: '251.187%',
      colorSet: [{
        offset: 0,
        stopColor: GRADIENT_MANTLE_START
      }, {
        offset: 1,
        stopColor: GRADIENT_MANTLE_END
      }]
    }
  }
};
export default {
  light: gradientViewConfig,
  dark: gradientViewConfig,
  white: gradientViewConfig
};